module.exports = __webpack_public_path__ + "media/images/smart_phone/ticket/progress_01-341d1dcd216fab71e88e0007fdc239b8.png";